// extracted by mini-css-extract-plugin
export default {"parallax":"parralaxText_parallax__J7Wqp","scroller":"parralaxText_scroller__j0lbn"};